<template>
  <v-data-table
    :loading="loading"
    :headers="headersByType"
    :items="lines"
    :sort-by="sortBy"
    :sort-desc="sortDesc"
    :footer-props="footerProps"
    :custom-sort="defaultSorting"
  >
    <template v-slot:item.date="item">
      {{ item.item.date | dateFormat }}
    </template>
    <template v-slot:item.duration="{ item }">
      {{ item.duration_hours || item.duration }}
    </template>
    <template v-slot:item.unit_price="{ item }">
      {{ item.unit_price | priceFormat }}
    </template>
    <template v-slot:item.price="{ item }">
      {{ item.price | priceFormat }}
    </template>
    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <slot name="actions" :item="item"></slot>
      </div>
    </template>

    <template v-slot:body.append="{ headers }">
      <slot name="body-append" :headers="headers"></slot>

      <tr>
        <td :colspan="headers.length - 2"></td>
        <td class="text-right text-body-1 font-weight-bold">
          {{ $t('EREPORTER.TOTAL') }}: {{ totalPrice | priceFormat }} CHF
        </td>
        <td></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex';
import { dateFormat, priceFormat } from '@/modules/_global/filters';
import { sortItems } from 'vuetify/lib/util/helpers';

export const BASE = 'base';
export const C = 'c';

export const types = Object.freeze({
  BASE,
  C
});

export default {
  name: 'InvoiceLineList',

  filters: {
    dateFormat,
    priceFormat
  },

  props: {
    lines: {
      type: Array,
      default: () => []
    },
    totalPrice: {
      type: [String, Number],
      default: 0
    },
    sortBy: {
      type: [String, Array],
      default: 'date'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    type: {
      type: String,
      default: 'base',
      validator: prop => Object.values(types).includes(prop)
    }
  },

  data: () => ({
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    },
    columnsByType: {
      base: [0, 1, 2, 3, 4, 7, 8],
      c: [0, 1, 2, 3, 5, 6, 7, 8]
    }
  }),

  computed: {
    ...mapState(['loading']),

    headers() {
      return [
        {
          text: this.$t('ITEM.DATE'),
          sortable: true,
          value: 'date'
        },
        {
          text: this.$t('SERVICES.ITEM'),
          sortable: true,
          value: 'title'
        },
        {
          text: this.$t('EREPORTER.INVOICES.INVOICE_NOTE'),
          sortable: true,
          value: 'invoice_note'
        },
        {
          text: this.$t('ITEM.DURATION'),
          sortable: true,
          value: 'duration'
        },
        {
          text: this.$t('EREPORTER.INVOICES.PRICE_CURRENCY_UNIT'),
          sortable: true,
          value: 'unit_price',
          align: 'right'
        },
        {
          text: this.$t('CONTRACTS.PRICE_MONTH'),
          sortable: true,
          value: 'unit_price',
          align: 'right'
        },
        {
          text: this.$t('CONTRACTS.PRICE_MONTH_EMPTY'),
          sortable: true,
          value: 'empty_price',
          align: 'right'
        },
        {
          text: this.$t('EREPORTER.INVOICES.TOTAL_PRICE'),
          sortable: true,
          value: 'price',
          align: 'right'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    },

    headersByType() {
      const columnsIndexes = this.columnsByType[this.type];

      return this.headers.filter((item, index) => {
        return columnsIndexes.indexOf(index) !== -1;
      });
    }
  },

  methods: {
    defaultSorting(items, sortBy, sortDesc) {
      if (sortBy.includes('default') || !sortBy.length) {
        items.sort((a, b) => {
          if (a.date > b.date) {
            return 1;
          }

          if (a.date < b.date) {
            return -1;
          }

          return 0;
        });

        return items;
      }

      return sortItems(items, sortBy, sortDesc);
    }
  }
};
</script>
